// extracted by mini-css-extract-plugin
export default {"textArea":"TextArea_textArea__mthJ0","customInput":"TextArea_customInput__d6lvN","customInputError":"TextArea_customInputError__4KQvM","errorMessage":"TextArea_errorMessage__f78ls"};